const DEFAULT_OPTIONS = {
  components: 'country:th',
  types: ['geocode'],
  strictbounds: false
};

/**
 * Convert a complex Google Place suggestion into a simple PlaceSuggestion object
 *
 * @param {Object} [suggestion] - a Google Place suggestion
 * @return {Object} - a formatted place suggestion object
 */
const PlaceSuggestion = (suggestion) => {
  /* eslint-disable camelcase */
  const { place_id, description, structured_formatting } = suggestion;
  return {
    id: place_id,
    description: description,
    main_text: structured_formatting.main_text,
    secondary_text: structured_formatting.secondary_text
  };
  /* eslint-enable camelcase */
};

class GeolocationManager {
  constructor(options = {}) {
    this.options = {...DEFAULT_OPTIONS, ...options};
  }

  /**
   * Get the place predictions based on a text string.
   * Uses Google Place Predictions:
   * https://developers.google.com/maps/documentation/javascript/reference#AutocompletionRequest
   *
   * @param {String} [inputText] - string for which the suggestions are to be found
   * @return {Promise} - a promise which will resolve to the place details
   */
  getPlaceSuggestions(inputText) {
    let placesService = new google.maps.places.AutocompleteService();

    return new Promise((resolve, reject) => {
      placesService.getPlacePredictions({ input: inputText, ...this.options }, (suggestions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          suggestions = suggestions.filter(suggestion => {
            return suggestion.terms.length === 2;
          });
          if (suggestions.length > 0) {
            const formattedSuggestions = suggestions.map(suggestion => {
              return PlaceSuggestion(suggestion);
            });

            resolve(formattedSuggestions);
          } else {
            reject(
              // eslint-disable-next-line camelcase
              new Error(I18n.t('geolocation_manager.error.no_suggestion_found', { search_text: inputText }))
            );
          }
        } else {
          reject(
            // eslint-disable-next-line camelcase
            new Error(I18n.t('geolocation_manager.error.no_suggestion_found', { search_text: inputText }))
          );
        }
      });
    });
  }

  /**
   * Fetches the details of a place identified by `placeId`
   * Uses Google Place Details:
   * https://developers.google.com/maps/documentation/javascript/places#place_details
   *
   * @param {String} [placeId] - google place_id of the place
   */
  getPlaceDetails(placeId) {
    const request = {
      placeId: placeId
    };

    return new Promise((resolve, reject) => {
      let service = new google.maps.places.PlacesService(document.createElement('div'));
      service.getDetails(request, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(place);
        } else {
          reject(
            new Error(I18n.t('geolocation_manager.error.place_detail_failure'))
          );
        }
      });
    });
  }
}

export default GeolocationManager;



// WEBPACK FOOTER //
// ./app/assets/javascripts/lib/geolocationManager.js